import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import {useLocation} from 'react-router-dom';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ContentTitle } from '../ui/styled';
import { Auth } from 'aws-amplify';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import { REPORT_DIRECTORY_URL } from '../../constants';
import { renderCellExpand } from '../common/GridCell/GridCellExpand';
import { getDirectoryReport } from './services/reportsApi';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { LeftGrid } from '../Episode/Episode.Styled';
import Button from '@mui/material/Button';

const DirectoryList = (props) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [directoryList, setDirectoryList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1, 
    pageSize: 10,
  });

  let totMales = 0;
  let totFemales = 0;

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    setDirectoryList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = commonQueryParams(
      REPORT_DIRECTORY_URL + location.state.asOfDate,
      null,
      directoryList
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const report = await getDirectoryReport({
      commonParams,
      authorization,
    });
    setDirectoryList((prveState) => ({
      ...prveState,
      ...report,
    }));
  };
  
  return (
    <>
      <ContentTitle container>
        <Grid item xs={6}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title='Directory' />
          </Box>
        </Grid>
        <LeftGrid item xs={6}>
          <Button
            variant='contained'
            style={{ justifyContent: 'flex-end' }}
            onClick={() => handlePrint()}
          >
            Print
          </Button>
        </LeftGrid>
      </ContentTitle>
    <Box px={4} ref={componentRef}>  
      <Grid item xs={12}>
        <Box p={2} style={{ alignItems: 'center' }}>
          <Typography variant='h4' align='center'>Directory Report as of {location.state.asOfDate}</Typography>
        </Box>
      </Grid>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={{backgroundColor: '#000'}}
            >
              <TableCell sx={{color: '#fff'}}>County</TableCell>
              <TableCell sx={{color: '#fff'}}>OrgID</TableCell>
              <TableCell sx={{color: '#fff'}}>Org Name</TableCell>
              <TableCell sx={{color: '#fff'}}>Org Address</TableCell>
              <TableCell sx={{color: '#fff'}}>Org City</TableCell>
              <TableCell sx={{color: '#fff'}}>Org State</TableCell>
              <TableCell sx={{color: '#fff'}}>Org Zip</TableCell>
              <TableCell sx={{color: '#fff'}}>Modality</TableCell>
              <TableCell sx={{color: '#fff'}} align="right">Males</TableCell>
              <TableCell sx={{color: '#fff'}} align="right">Females</TableCell>
              <TableCell sx={{color: '#fff'}} align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              directoryList.data.map((row) => {
                totMales += row.males;
                totFemales += row.females
                return(
                  <TableRow
                    key={row.orgID}
                    sx={{ '&:nth-of-type(odd)': {backgroundColor: '#eee'}, '&:last-child td, &:last-child th': { border: 0} }}
                  >
                    <TableCell component="th" scope="row">
                      {row.cnyName}
                    </TableCell>
                    <TableCell>{row.orgID}</TableCell>
                    <TableCell>{row.orgName}</TableCell>
                    <TableCell>{row.orgAdr}</TableCell>
                    <TableCell>{row.orgCity}</TableCell>
                    <TableCell>{row.orgState}</TableCell>
                    <TableCell>{row.orgZip}</TableCell>
                    <TableCell>{row.cbo_ModID}</TableCell>
                    <TableCell align="right">{row.males}</TableCell>
                    <TableCell align="right">{row.females}</TableCell>
                    <TableCell align="right">{row.total}</TableCell>
                  </TableRow>
                )
              })

            }
              <TableRow
                sx={{ backgroundColor: '#000'}}
              >
                <TableCell component="th" scope="row">
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell sx={{color: '#fff', fontWeight: '600'}}>Totals</TableCell>
                <TableCell sx={{color: '#fff', fontWeight: '600'}} align="right">{totMales}</TableCell>
                <TableCell sx={{color: '#fff', fontWeight: '600'}} align="right">{totFemales}</TableCell>
                <TableCell sx={{color: '#fff', fontWeight: '600'}} align="right">{totMales + totFemales}</TableCell>
              </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>  

    </>
  );
};
export default DirectoryList;
